import { catUrl, parseFilterFromPath, parseFilterFromQuery } from './filterUrl';
import { requireEl } from './dom';

const FILTER_LABELS: Record<string, string> = { all: 'все фото', liked: 'мои лайки' };
const VALID_FILTERS = new Set<string>();

document.querySelectorAll<HTMLButtonElement>('.bar button[data-filter]').forEach(b => {
  const filter = b.dataset.filter;
  if (!filter) return;
  if (filter !== 'all') FILTER_LABELS[filter] = b.textContent ?? filter;
  VALID_FILTERS.add(filter);
});

export { catUrl };

export function filterFromUrl(): string {
  const cat = new URLSearchParams(location.search).get('cat');
  if (cat !== null) {
    return parseFilterFromQuery(cat, VALID_FILTERS);
  }
  return parseFilterFromPath(location.pathname, VALID_FILTERS);
}

type CrumbItem = {
  href?: string;
  text: string;
  cat?: string;
  current?: boolean;
};

export function updateCrumbs(name: string, setFilter: (name: string) => void): void {
  const ol = requireEl<HTMLOListElement>('crumbs');
  const label = FILTER_LABELS[name] || name;
  const items: CrumbItem[] = [
    { href: 'https://imagecat.ru/', text: 'imagecat.ru' },
    { href: '/', text: 'главная' },
    { href: catUrl('all'), text: 'альбом «котики»', cat: 'all' },
  ];
  if (name !== 'all') {
    items.push({ href: catUrl(name), text: label, current: true });
  } else {
    items[items.length - 1].current = true;
  }

  ol.replaceChildren();
  for (const it of items) {
    const li = document.createElement('li');
    if (it.current) {
      li.setAttribute('aria-current', 'page');
      li.textContent = it.text;
    } else {
      const a = document.createElement('a');
      a.href = it.href ?? '#';
      a.textContent = it.text;
      if (it.cat !== undefined) {
        a.dataset.cat = it.cat;
        a.addEventListener('click', e => {
          e.preventDefault();
          setFilter(it.cat!);
        });
      }
      li.appendChild(a);
    }
    ol.appendChild(li);
  }

  const ld = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.text,
      ...(it.href && !it.current
        ? { item: it.href.startsWith('http') ? it.href : 'https://imagecat.ru' + it.href }
        : {}),
    })),
  };
  let script = document.getElementById('crumbs-ld') as HTMLScriptElement | null;
  if (!script) {
    script = document.createElement('script');
    script.id = 'crumbs-ld';
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(ld);
}

export function bindFilters(applyFilter: (name: string, pushHistory: boolean) => void): void {
  document.querySelectorAll<HTMLButtonElement>('.bar button[data-filter]').forEach(btn => {
    btn.onclick = () => {
      const f = btn.dataset.filter;
      if (!f || f === 'all' || btn.classList.contains('on')) {
        applyFilter('all', true);
      } else {
        applyFilter(f, true);
      }
    };
  });
}

export { FILTER_LABELS };
